import { useState, useCallback } from 'react';

export const usePartsManagement = () => {
    const [selectedParts, setSelectedParts] = useState([]);
    const [manualParts, setManualParts] = useState([]);
    const [newManualPart, setNewManualPart] = useState({ name: '', quantity: 1 });

    const handlePartSelection = useCallback((part) => {
        if (part.stock > 0) {
            setSelectedParts((prev) => {
                const existing = prev.find((p) => p.id === part.id);
                if (existing) {
                    return prev.map((p) =>
                        p.id === part.id
                            ? { ...p, quantity: Math.min(p.quantity + 1, part.stock) }
                            : p
                    );
                }
                return [...prev, { ...part, quantity: 1 }];
            });
        }
    }, []);

    const removePart = useCallback((partId) => {
        setSelectedParts((prev) => prev.filter((p) => p.id !== partId));
    }, []);

    const removeManualPart = useCallback((index) => {
        setManualParts((prev) => prev.filter((_, i) => i !== index));
    }, []);

    const updatePartQuantity = useCallback((partId, quantity) => {
        setSelectedParts((prev) =>
            prev.map((p) =>
                p.id === partId ? { ...p, quantity: Math.max(1, quantity) } : p
            )
        );
    }, []);

    const updateManualPartQuantity = useCallback((index, quantity) => {
        setManualParts((prev) =>
            prev.map((part, i) =>
                i === index ? { ...part, quantity: Math.max(1, quantity) } : part
            )
        );
    }, []);

    const addManualPart = useCallback(() => {
        if (newManualPart.name.trim()) {
            setManualParts((prev) => [
                ...prev,
                {
                    ...newManualPart,
                    id: `manual-${Date.now()}`,
                    timestamp: Date.now(),
                },
            ]);
            setNewManualPart({ name: '', quantity: 1 });
        }
    }, [newManualPart]);

    const updateNewManualPart = useCallback((updates) => {
        setNewManualPart((prev) => ({ ...prev, ...updates }));
    }, []);

    const resetParts = useCallback(() => {
        setSelectedParts([]);
        setManualParts([]);
        setNewManualPart({ name: '', quantity: 1 });
    }, []);

    return {
        selectedParts,
        manualParts,
        setSelectedParts,
        setManualParts,
        newManualPart,
        setNewManualPart,
        handlePartSelection,
        removePart,
        removeManualPart,
        updatePartQuantity,
        updateManualPartQuantity,
        addManualPart,
        updateNewManualPart,
        resetParts,
    };
};
